// Monday = 0, matching the backend weekday numbering.
export const weekdayName = (weekday: number, locale: string): string => {
  const monday = new Date(2024, 0, 1);
  const date = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + weekday);
  return new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(date);
};

export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6] as const;

// The API sends HH:MM:SS, <input type="time"> works with HH:MM.
export const fromApiTime = (value: string | null | undefined): string =>
  value ? value.slice(0, 5) : '';

export const toApiTime = (value: string): string | null => (value ? `${value}:00` : null);

export const formatDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} min`;
  return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`;
};

export const buildBookingUrl = (slug: string): string => `${window.location.origin}/book/${slug}`;
